import {ApiBase} from "@/src/model/ApiBase";
import {GRAPH_API_TYPE} from "@/src/model/apiTypes";

export class GraphApi extends ApiBase {
    async [GRAPH_API_TYPE.GET_GRAPH]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/`)
    }

    async [GRAPH_API_TYPE.ADD_GRAPH]({workspace_id, name, datamodel_id, pac_project_key, leading_object_table, datapool_id, definition, activity_table}) {
        return await this.httpPost(`workspaces/${workspace_id}/graphs/`, {
            name,
            datamodel_id,
            pac_project_key,
            datapool_id,
            leading_object_table,
            definition,
            activity_table
        })
    }

    async [GRAPH_API_TYPE.CLEAN_UP_RESULTS]({graphId, data}) {
        return await this.httpPost(`graphs/${graphId}/cleanup/`, data)
    }

    async [GRAPH_API_TYPE.PUBLISH_GRAPH]({graphId, description}) {
        return await this.httpPut(`graphs/${graphId}/publish/`, {description});
    }

    async [GRAPH_API_TYPE.UPDATE_GRAPH]({graphId, data}) {
        return await this.httpPatch(`graphs/${graphId}/`, data)
    }

    async [GRAPH_API_TYPE.DELETE_GRAPH]({graphId}) {
        return await this.httpDelete(`graphs/${graphId}/`)
    }

    async [GRAPH_API_TYPE.DELETE_GRAPHS](graphIds) {
        return await this.httpPost(`graphs/delete/`, {graph_ids: graphIds})
    }

    async [GRAPH_API_TYPE.RUN_JOB]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/job/run/`)
    }

    async [GRAPH_API_TYPE.CANCEL_JOB]({graphId}) {
        return await this.httpPost(`graphs/${graphId}/job_executions/cancel/`)
    }

    async [GRAPH_API_TYPE.LAST_JOB_EXECUTION]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/job/job_executions/?count=1&logs`)
    }

    async [GRAPH_API_TYPE.JOB_EXECUTIONS]({graphId, count, from}) {
        return await this.httpGet(`graphs/${graphId}/job/job_executions/?count=${count}&from=${from}&logs`)
    }

    async [GRAPH_API_TYPE.JOB_EXECUTION_LOGS]({graphId, jobExecutionId}) {
        return await this.httpGet(`graphs/${graphId}/job/job_executions/${jobExecutionId}/logs`)
    }

    async [GRAPH_API_TYPE.JOB_EXECUTION_COUNT]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/job/job_executions/count/`)
    }

    async [GRAPH_API_TYPE.GET_VERSIONS]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/versions/`)
    }

    async [GRAPH_API_TYPE.RESTORE_VERSION]({graphId, versionId}) {
        return await this.httpPut(`graphs/${graphId}/versions/${versionId}/restore/`);
    }

    async [GRAPH_API_TYPE.GET_PERMISSIONS]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/permissions/`)
    }

    async [GRAPH_API_TYPE.GET_USER_PERMISSIONS]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/permissions/user/`)
    }

    async [GRAPH_API_TYPE.UPDATE_PERMISSIONS]({spaceId, graphId, data}) {
        return await this.httpPost(`graphs/${graphId}/permissions/`, data)
    }

    async [GRAPH_API_TYPE.LOCK_GRAPH]({graphId}) {
        return await this.httpPost(`graphs/${graphId}/lock/`)
    }

    async [GRAPH_API_TYPE.UNLOCK_GRAPH]({graphId}) {
        return await this.httpPost(`graphs/${graphId}/lock/`, {unlock: true})
    }

    async [GRAPH_API_TYPE.GET_LOCK]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/lock/`)
    }

    async [GRAPH_API_TYPE.GET_RESULTS]({spaceId}) {
        return await this.httpGet(`workspaces/${spaceId}/results/`)
    }

    async [GRAPH_API_TYPE.IMPORT_BPMN]({workspaceId, formData}) {
        return await this.httpPost(`workspaces/${workspaceId}/bpmn/`, formData)
    }

    async [GRAPH_API_TYPE.SHARE_GRAPH]({graphId, data}) {
        return await this.httpPost(`graphs/${graphId}/share/`, data)
    }

    async [GRAPH_API_TYPE.MOVE_GRAPHS](data) {
        return await this.httpPost(`graphs/move/`, data)
    }
    async [GRAPH_API_TYPE.PREVIEW_ADHERENCE]({graphId, data}) {
        return await this.httpPost(`graphs/${graphId}/preview-adherence/`, data)
    }

    async [GRAPH_API_TYPE.PREVIEW_ADHERENCE_STATE]({graphId}) {
        return await this.httpGet(`graphs/${graphId}/preview-adherence/`)
    }

}

